import { render } from "./PlayForm.vue?vue&type=template&id=35ee16e3&scoped=true"
import script from "./PlayForm.vue?vue&type=script&lang=js"
export * from "./PlayForm.vue?vue&type=script&lang=js"

import "./PlayForm.vue?vue&type=style&index=0&id=35ee16e3&scoped=true&lang=css"

import exportComponent from "/home/runner/work/somosteatro/somosteatro/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35ee16e3"]])

export default __exports__